export function initMainNavigation(): void {
  let isOpen = false;

  const header = document.querySelector<HTMLElement>("header.header");
  const toggle =
    header?.querySelector<HTMLAnchorElement>(".mobile-toggle") ?? null;

  const setBodyScrollLock = (lock: boolean) => {
    document.body.classList.toggle("menu-open", lock);
  };

  const sync = () => {
    if (!header || !toggle) return;
    toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    header.classList.toggle("show-menu", isOpen);
    setBodyScrollLock(isOpen);
  };

  if (!header || !toggle) return;

  const onKeydown = (event: KeyboardEvent) => {
    if (event.key === "Escape" && isOpen) {
      isOpen = false;
      sync();
    }
  };

  const onClickOutside = (event: MouseEvent) => {
    if (!header || !isOpen) return;
    const target = event.target as Node;
    if (!header.contains(target)) {
      isOpen = false;
      sync();
    }
  };

  toggle.addEventListener("click", (event) => {
    event.preventDefault();
    isOpen = !isOpen;
    sync();
  });

  document.addEventListener("keydown", onKeydown);
  document.addEventListener("click", onClickOutside);

  sync();
}
